import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import config from "@/config";

jest.mock("@/config", () => ({
  getPasoProperties: jest.fn(arg => {
    console.log("Mock called with argument:", arg);
  })
}));

jest.mock("@/store", () => ({
  dispatch: jest.fn()
}));

describe("router", () => {
  beforeEach(() => {
    Vue.use(Router);
    jest.spyOn(config, "getPasoProperties");
    jest.spyOn(store, "dispatch");
  });

  afterEach(() => {
    jest.restoreAllMocks();
  });

  it("should set up the router with the correct scroll behavior", () => {
    const mockScrollBehavior = jest.fn().mockReturnValue({ x: 0, y: 0 });
    const mockRouter = new Router({ scrollBehavior: mockScrollBehavior });

    const mockVueInstance = new Vue({
      router: mockRouter
    });

    const result = mockVueInstance.$router;

    expect(result).toBeInstanceOf(Router);
    expect(result.options.scrollBehavior).toBe(mockScrollBehavior);
  });
});
